export class IndividualPhoneModel {
  public cph_key: string = undefined;
  public cph_pht_key: string = undefined;
  public cph_primary = false;
  public cph_phn_number_complete: string = undefined;
  public cph_extension: string = undefined;
  public phn_number: string = undefined;
  public phn_number_display: string = undefined;
  public phn_cty_key: string = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
